import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { OrganisationsAutocomplete } from '~components';
import ResourceGroupAutocomplete from '~components/inputFields/autocompletes/resourceGroupAutocomplete';
import Organisation from '~interfaces/organisation';
import ResourceGroup from '~interfaces/resourceGroup';

import Dimens from '../../../../themes/dimens';

interface FormValues {
	organisation: Organisation | undefined;
	resourceGroup: ResourceGroup | undefined;
}

interface Props {
	organisation: Organisation | undefined;
	resourceGroup?: ResourceGroup | undefined;
	onValuesChanged: (newValues: FormValues) => void;
	resourceGroupDisabled?: boolean;
	showEditOrganisation?: boolean;
}

const SelectOrganisationAndResourceGroupForm = ({
	organisation,
	resourceGroup,
	onValuesChanged,
	resourceGroupDisabled = false,
	showEditOrganisation = true,
}: Props) => {
	const { t } = useTranslation();

	return (
		<Stack spacing={Dimens.spacingMd}>
			{showEditOrganisation && (
				<OrganisationsAutocomplete
					value={organisation?.id}
					label={t('organisation.labels.single', { ns: 'entities' }) + '*'}
					onValueChanged={(newValue) => {
						onValuesChanged({
							organisation: newValue,
							resourceGroup: undefined,
						});
					}}
					required
					sx={{ width: '100%' }}
				/>
			)}
			<ResourceGroupAutocomplete
				value={resourceGroup?.id}
				label={t('resourceGroup.labels.single', { ns: 'entities' })}
				disabled={resourceGroupDisabled}
				filterOrganisationId={organisation?.id}
				onValueChanged={(newValue) => {
					onValuesChanged({
						organisation: organisation,
						resourceGroup: newValue,
					});
				}}
				sx={{ width: '100%' }}
			/>
		</Stack>
	);
};

export default SelectOrganisationAndResourceGroupForm;
